import { breakpoints } from '../config';

export function getDeviceBreakpoint(width) {
    const { mobile, tablet } = breakpoints;

    if (mobile.small && width <= mobile.small) {
        return 'mobile-small';
    } else if (mobile.normal && width > mobile.small && width <= mobile.normal) {
        return 'mobile-normal';
    } else if (tablet && width > mobile.normal && width <= tablet) {
        return 'tablet';
    }

    return 'desktop';
}



/** WEBPACK FOOTER **
 ** /src/shared/service/device.js
 **/